import { graphql, StaticQuery } from 'gatsby';
import React, { useState } from 'react';
import styles from '../../style/iso50001.module.css'
import { StaticImage } from 'gatsby-plugin-image'
import { AnchorLink } from 'gatsby-plugin-anchor-links';

// const Iso = ({data}) => {
//         <div>
//             <div className={styles.container}>
//                 <div className={styles.layout}>
//                     <div className={styles.wrapper}>
//                         <h1>ЭРЧИМ ХҮЧНИЙ МЕНЕЖМЕНТИЙН ТОГТОЛЦООНЫ ISO 50001 СТАНДАРТ ГЭЖ ЮУ ВЭ?</h1>
//                         <p>Эрчим хүч бол байгууллагын нэн чухал асуудал бөгөөд байгууллагад болон хүрээлэн буй орчинд аль алинд нь их хэмжээний өртөг зардал учруулж байдаг. Дэлхийн эрчим хүчний хэрэглээ өссөөр байгаа бөгөөд сүүлийн 40 жилийн хугацаанд 2 дахин нэмэгдсэн Түүнчлэн 2030 он хүртэл 30% өсөх тооцоо гарчээ. Дэлхийн уур амьсгалын өөрчлөлтийн зонхилох шалтгаан болох хүлэмжийн хийн ялгаруулалтын гуравны хоёр нь эрчим хүчний үйлдвэрлэл, хэрэглээнээс үүсч байна. ISO 50001 стандарт хэвлэгдэн гарснаас хойш ач холбогдол нь өссөөр байгаа ба одоогоор 7000 гаруй байгууллага уг стандартын дагуу баталгаажаад байна.
//                         {console.log(data)}
//                         {moreText}
//                              </p>
//                         <button onClick={myFunction} className={styles.button}>{btnText}</button>
//                     </div>
//                 </div>
//             </div>
//         </div>
// // }
// const IsoQuery = () =>{
//     return(
//         <StaticQuery
//         query={graphql`
//         query {
//             allMarkdownRemark {
//               nodes {
//                 html
//               }
//             }
//           }`}
//           render={data => <Iso data={data}/>}
//           />
//     )
// }

export default function IsoQuery(){
    return(
        <StaticQuery
        query={graphql`
        query PostsPage {
            allMarkdownRemark {
              nodes {
                html
                frontmatter {
                  title
                }
              }
            }
          }`}
          render={data => <Iso data={data.allMarkdownRemark}/>} 
          />
    )
}
function Iso( {data} ) {
    const [readMore, setReadMore]= useState(false);
    const [btnText, setBtnText] = useState('Read more');
    const [moreText, setMoreText] = useState('...')
    const myFunction = () =>{
        if (readMore) {
          setReadMore(!readMore)
          setBtnText('Read more')
          setMoreText('...')
        } else {
          setReadMore(!readMore)
          setBtnText('Read less')
          setMoreText(more)
        }
    }
    const more = () =>{
        return(
            <div className={styles.html} dangerouslySetInnerHTML={{ __html: data.nodes[1].html}}/>
        )
    }
    return(
        <div>
            <div className={styles.container}>
                <div className={styles.layout}>
                    <div className={styles.wrapper}>
                        <h1 className="title"><span className="underline">ЭРЧИМ ХҮЧНИЙ УДИРДЛАГЫН ТОГТОЛЦОО ГЭЖ ЮУ ВЭ?</span></h1>
                        <StaticImage src="../../images/iso_icon.JPG" alt="logo" style={{maxWidth: '200px'}}/>
                        <div className={styles.button_container}>
                          <div>
                          <p>Эрчим хүчний удирдлагын тогтолцоо нь байгууллага эрчим хүчний хэрэглээгээ илүү сайн удирдахад тусална. Үүнд эрчим хүчний бодлогоо бий болгох, хэрэгжүүлэх, эрчим хүчний хэрэглээний зорилгоо тодорхойлох болон түүнд хүрэх үйл ажиллагааны төлөвлөгөө боловсруулах зэрэг хамаарна. Түүнчлэн эрчим хүчний үр ашигтай технологийг хэрэгжүүлэх, эрчим хүчний алдагдлыг багасгах, өртөгийг бууруулах зорилгоор үйл ажиллагааг сайжруулах зэрэг хамаарна.
                         
                          {moreText} </p>
                          <button onClick={myFunction} className={styles.button}>{btnText}</button>


                          <h2>ISO-50001 стандарт таны бизнест ямар үр өгөөж авчрах вэ?</h2>
                          <p>
                          Эрчим хүчний хэрэглэдэг байгууллага аж ахуйн нэгжүүд ISO 50001 стандартыг хэрэгжүүлснээр эрчим хүчийг хэмнэх нь дан ганц эрчим хүч хариуцсан техникийн ажилтны үүрэг биш гэдгийг ойлгосон бүх шатны ажилтнууд хоорондоо стандартын нэг хэлээр ойлголцож, эрчим хүчний зардлаа бууруулах тал дээр хамтран ажилласнаар байгууллагын бизнесийн ашиг нэмэгдэнэ, хамт олны дунд эрчим хүчний зохистой хэрэглээний зөв дадал сууж эрчим хүчийг зохистой хэрэглэснээр байгаль орчинд үзүүлэх сөрөг нөлөөлөл багасаж, байгууллагын нэр хүнд өснө. Мөн бизнесийн урт хугацааны тогтвортой байдал хангагдана. Тиймээс ISO 50001 стандартыг дэлхий даяар том, жижиг аж ахуйн нэгжүүд хэрэгжүүлсээр байна.
                          </p>
                          <h2>ISO-50001 стандартыг хэн хэрэгжүүлэх боломжтой вэ?</h2>
                          <p>
                          ISO 50001 стандартыг Удирдлагын тогтолцооны бусад стандартуудын адил төрийн болон хувийн хэвшлийн байгууллагууд өмчлөлийн хэлбэр, үйл ажиллагааны чиглэл, хамрах хүрээ, газар зүйн байрлал, эрчим хүчний хэрэглээний цар хүрээ болон гүйцэтгэлийн одоогийн түвшингээс үл хамааран хэрэгжүүлэх боломжтой. 
                          </p>
                          <h2>ISO-50001 стандартыг хэрхэн баталгаажуулах вэ?</h2>
                          <p>
                          Удирдлагын тогтолцооны бусад ISO стандартуудын нэгэн адил ISO 50001 стандартыг хэрэгжүүлэх нь тухайн байгууллага болон хувьцаа эзэмшигчид, хэрэглэгчдэд дотоод ба гадаад үр ашгийг авчирдаг. Хөндлөнгийн аудитороор үнэлгээ хийлгэж, баталлгаажуулалтын гэрчилгээ авах нь стандартын өөрийнх нь эцсийн зорилго биш боловч энэ нь бизнесийн нэр хүндийн нэрийн хуудас болдог учир байгууллагын удирдлага ISO 50001 стандартын баталгаажуулалтын гэрчилгээ авах сонирхолтой байдаг. 
                          </p>
                          <h2>ISO-50001 стандарт нэвтрүүлэх, баталгаажуулах процесс</h2>
                          <StaticImage src="../../images/iso-scheme.JPG" alt="hemjilt"/>
                          <p>
                          Танай байгууллагад Эрчим хүчний удирдлагын тогтолцооны ISO-50001 стандарт нэвтрүүлэхэд зөвлөх үйлчилгээ шаардлагатай байгаа бол <AnchorLink to="/#contact" className={styles.link}>энд</AnchorLink> дарж дэлгэрэнгүй мэдээлэл авна уу. 
                          </p>
                          </div>
                         
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
